
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class TimeSinceLastVisitPivot extends Vue {

  headerTranslations: Record<string, string> = {
    ["Less than 12 months"]: "Weniger als 12 Monate",
    ["12–<24 months"]: "12–<24 Monate",
    ["24–<60 months"]: "24–<60 Monate",
    ["≥ 60 months"]: "≥ 60 Monate"
  };

  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("timeSinceLastVisitPivot");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("timeSinceLastVisitPivot");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
